import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

const QUILL_MODULES = {
  toolbar: [['bold', 'italic', { color: [] }], ['clean']],
};

const QUILL_FORMATS = ['bold', 'italic', 'color'];

const useStyles = makeStyles((theme) => ({
  root: {
    '& .ql-toolbar': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
    },
    '& .ql-container': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
      borderBottomLeftRadius: 4,
      borderBottomRightRadius: 4,
      fontFamily: 'inherit',
      fontSize: '0.875rem',
    },
    '& .ql-editor': {
      minHeight: 120,
    },
    '& .ql-container.ql-snow:focus-within': {
      borderColor: theme.palette.admin.primary.main,
    },
  },
  error: {
    '& .ql-toolbar, & .ql-container': {
      borderColor: theme.palette.error.main,
    },
  },
  errorText: {
    margin: '4px 14px 0',
    fontSize: '0.75rem',
    color: theme.palette.error.main,
  },
}));

interface Props {
  value: string;
  onChange: (html: string) => void;
  placeholder?: string;
  error?: boolean;
  helperText?: string;
}

/** Quill leaves a `<p><br></p>` shell when the editor is emptied: treat it as an empty value. */
export const isRichTextEmpty = (html: string): boolean =>
  html.replace(/<[^>]*>/g, '').replace(/\s|&nbsp;/g, '').length === 0;

export default function RichTextEditor({ value, onChange, placeholder, error, helperText }: Props) {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, error && classes.error)}>
      <ReactQuill
        theme="snow"
        value={value}
        modules={QUILL_MODULES}
        formats={QUILL_FORMATS}
        placeholder={placeholder}
        onChange={(html) => onChange(isRichTextEmpty(html) ? '' : html)}
      />
      {error && helperText && <p className={classes.errorText}>{helperText}</p>}
    </div>
  );
}
